
/**
 * setta un cookie
 */
function setCookie(cname, cvalue, exdays) {

    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires +"; path=/";

    return getCookie(cname);
}

/**
 * ritorna il valore del cookie
 */
function getCookie(cname) {

    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
}

/**
 * cancella il cookie
 */
function eraseCookie(name) {
    setCookie(name,"",-1);
}

function onConsent(preference) {
    console.log('onConsent', preference);
    eraseCookie('cookie_law_accepted');
    eraseCookie('cookie_law_accepted_1');
    eraseCookie('cookie_law_accepted_2');
    eraseCookie('cookie_law_accepted_3');
    eraseCookie('cookie_law_accepted_4');
    eraseCookie('cookie_law_accepted_5');

    setTimeout(function () {
        if (preference.consent) {
            dataLayer.push({'event': 'cookie_law_accepted'});
            setCookie('cookie_law_accepted', 1, 90);
            dataLayer.push({'event': 'cookie_law_accepted_1'});
            setCookie('cookie_law_accepted_1', 1, 90);
            dataLayer.push({'event': 'cookie_law_accepted_2'});
            setCookie('cookie_law_accepted_2', 1, 90);
            dataLayer.push({'event': 'cookie_law_accepted_3'});
            setCookie('cookie_law_accepted_3', 1, 90);
            dataLayer.push({'event': 'cookie_law_accepted_4'});
            setCookie('cookie_law_accepted_4', 1, 90);
            dataLayer.push({'event': 'cookie_law_accepted_5'});
            setCookie('cookie_law_accepted_5', 1, 90);
        } else if (preference.purposes) {
            if (preference.purposes[1]) {
                dataLayer.push({'event': 'cookie_law_accepted_1'});
                dataLayer.push({'cookie_law_var_1': 'accepted'});
                setCookie('cookie_law_accepted_1', 1, 90);
            }
            if (preference.purposes[2]) {
                dataLayer.push({'event': 'cookie_law_accepted_2'});
                dataLayer.push({'cookie_law_var_2': 'accepted'});
                setCookie('cookie_law_accepted_2', 1, 90);
            } else {
                dataLayer.push({'cookie_law_var_2': ''});
            }
            if (preference.purposes[3]) {
                dataLayer.push({'event': 'cookie_law_accepted_3'});
                dataLayer.push({'cookie_law_var_3': 'accepted'});
                setCookie('cookie_law_accepted_3', 1, 90);
            } else {
                dataLayer.push({'cookie_law_var_3': ''});
            }
            if (preference.purposes[4]) {
                dataLayer.push({'event': 'cookie_law_accepted_4'});
                dataLayer.push({'cookie_law_var_4': 'accepted'});
                setCookie('cookie_law_accepted_4', 1, 90);
            } else {
                dataLayer.push({'cookie_law_var_4': ''});
            }
            if (preference.purposes[5]) {
                dataLayer.push({'event': 'cookie_law_accepted_5'});
                dataLayer.push({'cookie_law_var_5': 'accepted'});
                setCookie('cookie_law_accepted_5', 1, 90);
            } else {
                dataLayer.push({'cookie_law_var_5': ''});
            }
        }
    }, 500);
}

if(iubenda_cookiePolicyId){


    var _iub = _iub || [];
    _iub.csConfiguration = {
        "whitelabel": false,
        "lang": iubenda_locale,
        "floatingPreferencesButtonDisplay": "bottom-left",
        "siteId": iubenda_siteId,
        "consentOnContinuedBrowsing": false,
        "perPurposeConsent": true,
        "cookiePolicyId": iubenda_cookiePolicyId,
        "callback": {
            "onPreferenceFirstExpressed": function(event) {
                onConsent(event);
            }
        },
        "banner": {
            "acceptButtonDisplay": true,
            "acceptButtonColor":"#c60017",
            "rejectButtonDisplay":true,
            "rejectButtonColor":"#4c4c4c",
            "customizeButtonDisplay": true,
            "position": "float-center"
        }
    };

    function iubenda__openPreferences(counter) {
        console.log('iubenda__openPreferences', counter);
        if (document.querySelector('.iubenda-cs-preferences-link')) {
            document.querySelector('.iubenda-cs-preferences-link').click();
        } else {
            if (counter < 10) {
                setTimeout(function (args) {
                    iubenda__openPreferences(counter + 1);
                }, 1000);
            }
        }
    }

    function iubenda__load(openPreferences) {
        console.log('iubenda__load');

        // hide fake button
        // document.getElementById('iubenda-copiaincolla-btn').remove();

        // load iubenda scripts
        var script = document.createElement('script');
        script.src = 'https://cdn.iubenda.com/cs/iubenda_cs.js';
        document.head.appendChild(script);

        if (openPreferences) {
            // trigger preference open
            iubenda__openPreferences(0);
        }
    }


    // init
    // if (
    //     !getCookie('cookie_law_accepted_1')
    //     && !getCookie('cookie_law_accepted_2')
    //     && !getCookie('cookie_law_accepted_3')
    //     && !getCookie('cookie_law_accepted_4')
    // ) {
    iubenda__load(false);
    // }
}